module.exports = __webpack_public_path__ + "img/cooperate_ability.8def17b2.svg";